module.exports = __webpack_public_path__ + "img/red-packet-cover.547dbb5b.png";